import {
  ACCESS_LIST_NAME,
  ACCESS_LIST_PATH,
  ACCOUNT_LIST_NAME,
  ACCOUNT_LIST_PATH,
  AGG_REPORT_LIST_NAME,
  AGG_REPORT_LIST_PATH,
  EPGU_LIST_NAME,
  EPGU_LIST_PATH,
  EPK_LIST_NAME,
  EPK_LIST_PATH,
  EPK_REPORT_LIST_NAME,
  EPK_REPORT_LIST_PATH,
  EXTRACT_LIST_NAME,
  EXTRACT_LIST_PATH,
  HEAD_LIST_NAME,
  HEAD_LIST_PATH,
  LPH_LIST_NAME,
  LPH_LIST_PATH,
  ORG_LIST_NAME,
  ORG_LIST_PATH,
} from '~packages/epk-front-router/routes.json';

import { IDefaultSidebarGroup } from '@/components/Layouts/EpkSidebar/types';

export default (hasRightWrite = false) => {
  const routes: IDefaultSidebarGroup[] = [
    {
      title: 'Похозяйственные книги',
      icon: 'books',
      to: { name: EPK_LIST_NAME },
      path: EPK_LIST_PATH,
    },
  ];

  routes.push({
    title: 'Реестр \n лицевых счетов',
    icon: 'registry',
    to: { name: ACCOUNT_LIST_NAME },
    path: ACCOUNT_LIST_PATH,
  });

  if (hasRightWrite) {
    routes.push({
      title: 'Реестр глав ЛПХ',
      icon: 'team',
      to: { name: HEAD_LIST_NAME },
      path: HEAD_LIST_PATH,
    });

    routes.push({
      title: 'Карточки ЛПХ',
      icon: 'cards',
      to: { name: LPH_LIST_NAME },
      path: LPH_LIST_PATH,
    });
  }
  if (hasRightWrite) {
    routes.push({
      title: 'Сводные книги',
      icon: 'summary-books',
      to: {
        name: EPK_REPORT_LIST_NAME,
        query: { period: '1' },
      },
      path: EPK_REPORT_LIST_PATH,
    });
  }
  routes.push({
    title: 'Агрегированные данные',
    icon: 'aggregated-books',
    to: { name: AGG_REPORT_LIST_NAME },
    path: AGG_REPORT_LIST_PATH,
  });

  if (hasRightWrite) {
    routes.push({
      title: 'Выписки',
      icon: 'statement',
      to: { name: EXTRACT_LIST_NAME },
      path: EXTRACT_LIST_PATH,
    });
  }

  if (hasRightWrite) {
    routes.push({
      title: 'Запросы с ЕПГУ',
      icon: 'gos',
      to: { name: EPGU_LIST_NAME },
      path: EPGU_LIST_PATH,
    });
  }

  routes.push({
    title: 'Права доступа',
    icon: 'policy',
    to: { name: ACCESS_LIST_NAME },
    path: ACCESS_LIST_PATH,
  });

  routes.push({
    title: 'Организации',
    icon: 'organization',
    to: { name: ORG_LIST_NAME },
    path: ORG_LIST_PATH,
  });

  return routes;
};
